
import {createSlice} from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: (state, action) => {

            //If quantity has become zero
            if(action.payload.quantity === 0){
                //Remove whole item from cart
                state.items = state.items.filter(item => item.id !== action.payload.id)
            }
            else{
                const itemIdx = state.items.findIndex(item => item.id === action.payload.id);
                
                //If item was not there in previous state
                if(itemIdx === -1) state.items.push(action.payload);
                //If it was there
                else state.items[itemIdx] = action.payload;
            }
            
        },
        clearCart: (state) => {
            state.items = [];
        }
    }
});

export const {addItem, clearCart} = cartSlice.actions;
export default cartSlice.reducer;